"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Example = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var __1 = require("../../");
var _1 = require("@/");
var GITHUB_SRC = 'https://github.com/vrimar/construct-ui/blob/master/src/';
var Example = /** @class */ (function () {
    function Example() {
        this.isDrawerOpen = false;
    }
    Example.prototype.view = function (_a) {
        var attrs = _a.attrs, children = _a.children;
        var className = attrs.class, options = attrs.options, _b = attrs.center, center = _b === void 0 ? true : _b, _c = attrs.direction, direction = _c === void 0 ? 'row' : _c, src = attrs.src;
        var content = [
            children,
            (0, mithril_1.default)(__1.Button, {
                class: 'cui-example-src-btn',
                iconLeft: __1.Icons.CODE,
                label: 'Source',
                size: 'xs',
                href: "".concat(GITHUB_SRC).concat(src),
                target: '_blank',
                rounded: true
            })
        ];
        return (0, mithril_1.default)('.cui-example', { class: className }, [
            (0, mithril_1.default)('.cui-example-content', {
                class: center ? 'cui-example-center' : '',
                style: "flex-direction:".concat(direction)
            }, content),
            this.renderOptions(options)
        ]);
    };
    Example.prototype.renderOptions = function (options) {
        var _this = this;
        var isXsSize = __1.ResponsiveManager.is('xs');
        var content = (0, mithril_1.default)('.cui-example-options', options);
        if (isXsSize) {
            return options && [
                (0, mithril_1.default)(__1.Button, {
                    class: 'cui-example-options-btn',
                    iconLeft: __1.Icons.SETTINGS,
                    onclick: function () { return _this.isDrawerOpen = true; },
                    size: 'xs',
                    rounded: true
                }),
                (0, mithril_1.default)(_1.Drawer, {
                    class: 'cui-example-mobile-drawer',
                    isOpen: this.isDrawerOpen,
                    onClose: function () { return _this.isDrawerOpen = false; },
                    position: 'bottom',
                    hasBackdrop: false,
                    content: content
                })
            ];
        }
        return options && content;
    };
    return Example;
}());
exports.Example = Example;
